/* Purpose: Pop up that displays available files from a specific loan that match the requested fieldName
 *          Users can choose a file from the list of available files 
 *          to be added to the fileList for the current loan that is open in the Loan tab
 * Props: ClientID (str)
 *        LoanID (str)
 *        credentials (map)
 *        fieldName (str)
 *        currentFiles (list)
 *        onUseFile (list of [func, map, index])
 * Author: R. Markowitz (April 2025)
 * Dev Notes: 
*/

import {Button, Alert} from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import React, {useState, useEffect} from 'react';

function FilesModal(props) {
    const ClientID = props.ClientID;
    const LoanID = props.LoanID;
    const credentials = props.credentials;
    const fieldName = props.fieldName;
    const getFile = props.onUseFile[0];
    const item = props.onUseFile[1];
    const index = props.onUseFile[2];
    const currentFiles = props.currentFiles;

    const [filePaths, setFilePaths] = useState();
    const [chosenFile, setChosenFile] = useState("");
    const [showNoFileAlert, setShowNoFileAlert] = useState(false);

    // Fetch loan file list
    useEffect(() => {
        const getFileInfo = async() => {
            try {
                const response = await fetch(`https://f0ll5x1c4l.execute-api.us-east-1.amazonaws.com/getLoanInfo`, {
                  "method": "POST",
                  "body": JSON.stringify({
                    "ClientID":ClientID,
                    "LoanID": LoanID,
                    "credentials": credentials
                  })
                });
                if (!response.ok) {
                    alert("Something went wrong when trying to get the file from ", LoanID, ". File not loaded.")
                }else{
                    const data = await response.json();
                    if (data && data.length !== 0){
                      if (data['LoanFiles'][fieldName] && data['LoanFiles'][fieldName].length != 0){
                        // Save the filepath from loan to item.value
                        let tempfilePaths = [];
                        data['LoanFiles'][fieldName].map((filePath) => {
                          // Do not display any files that are already uploaded for the loan that calls GFAL
                          if (!currentFiles.includes(filePath)){
                              tempfilePaths.push(filePath)
                          }
                        })
                        if (tempfilePaths.length == 0){
                          tempfilePaths = ["DISABLED/The relevant file from " + LoanID + " is already connected to your loan."]
                        }
                      setFilePaths(tempfilePaths);
                      }else{
                        setFilePaths(["DISABLED/There are no available files from this loan."])
                      }
                      
                    }else{
                        setFilePaths(["DISABLED/An error occured while trying to get a file from another loan."])
                        console.error("An error occured while trying to get a file from another loan. Data empty.")
                    }
                }
            }catch (error){
                console.error("An error occured while trying to get a file from another loan. Error: ", error)
                setFilePaths(["DISABLED/An error occured while trying to get a file from another loan."])
            }
        }

        getFileInfo();
    }, []);

  // When UseFile is clicked, check if a file was chosen to use.
  // If a file was chosen, get the file and hide the modal. If no file was chosen, tell the user
  const handleUseFile = (item, index, chosenFile) => {
    if (chosenFile){
      getFile(item, index, chosenFile, true);
      props.onHide();
    }else{
      setShowNoFileAlert(true);
    }
  };

  // Stop displaying the No File Chosen alert if a file is then chosen
  useEffect(() => {
    setShowNoFileAlert(false);
  }, [chosenFile])
    

  return (
    <Modal
      show = {true}
      onHide = {props.onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="GFAL-Modal">
            {LoanID}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul>
            {filePaths && filePaths.map((filePath, index) => (
              <>
                {filePath.split("/")[0] === "DISABLED"?(
                  <li>{filePath.split("/")[1]}</li>
                ):(
                  <li key = {index} id = {index}><a href= "#GFAL-Modal" onClick = {() => {setChosenFile(filePath)}}>{filePath.split("/")[1]}</a></li>
                )}
              </>
          ))} 
        </ul>           
      </Modal.Body>
      <Modal.Footer>
        <p>{chosenFile.split("/")[1]}</p>
        {showNoFileAlert && (
          <Alert variant = "danger">No file was chosen. Please choose a file to use then try USE FILE again.</Alert>
        )}
        <Button onClick={props.onHide}>Close</Button>
        <Button onClick={() => handleUseFile(item, index, chosenFile)}>Use File</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default FilesModal;